"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Pre = void 0;
var React = __importStar(require("react"));
var prism_1 = __importDefault(require("./prism"));
var classnames_1 = __importDefault(require("classnames"));
var Pre = function (_a) {
    var raw = _a.raw, style = _a.style, className = _a.className;
    return (React.createElement("pre", { className: (0, classnames_1.default)('language-javascript', className), style: __assign({ whiteSpace: 'pre-wrap', margin: '1em 0', fontSize: 13, borderRadius: 4 }, style) },
        React.createElement("code", { style: { padding: 0 }, className: "markdown-body", dangerouslySetInnerHTML: { __html: prism_1.default.highlight(raw, prism_1.default.languages.javascript, 'typescript') } })));
};
exports.Pre = Pre;
//# sourceMappingURL=Pre.js.map